import React, { useState } from 'react';
import { Modal, ModalHeader, Row, Col, Card, CardBody } from 'reactstrap';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import {
  getStateSpecificAWSLogo as getAWSLogo,
  getStateSpecificNRLogo as getNRLogo,
  getStateSpecificAzureLogo as getAzureLogo,
  getStateSpecificGCPLogo as getGCPLogo,
  getStateSpecificDatadogLogo,
  getStateSpecificSplunkLogo,
  getStateSpecificADLogo,
  getDynatraceLogo, getOciLogo,
  getGrafanaLogo, getSignozLogo

} from "../../../helpers/component_helpers";

function MapResourceServiceModal({
    type,
    isOpen,
    checkBox,
    filteredResources,
    handleCheckBox,
    serviceOptions,
    environments,
    handleServiceFormChange,
    handleEnvironmentChange,
    startLoading1,
    handleServiceMapping,
    cancelMapServiceModal,
}) {    
    const [btnHover, setBtnHover] = useState(false);
    const customOptionRenderer = (option) => {
        if (option.value === "/add-service") {
          return (
            <div 
              className="d-flex justify-content-center align-items-center gap-2 btn btn-soft-primary"
              onMouseEnter={() => setBtnHover(true)}
              onMouseLeave={() => setBtnHover(false)}
              style={{cursor:"pointer"}}>
              <i className={`fas fa-plus font-size-14 ${btnHover ? 'text-white' : 'text-primary'}`} />
              <span>
                {option.label}
              </span>
             
            </div>
          );
        } else {
          return option.label;
        }
      };

      const customStyles = {
        zIndex: 9999,
        control: (provided, state) => ({
          ...provided,
          background: '#382b42', // Background color of the control (react-select)
          borderRadius: 0,
          color: "white",
          zIndex: 100,
          position:"relative",
          borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
        }),
        option: (provided, state) => ({
          ...provided,
          position:"relative",
          zIndex: 100,
          backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',// Background color of dropdown options
          color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
        }),
        menu: (provided) => ({
          ...provided,
          background: '#382b42',
          position: "absolute",
          zIndex: 200, // Background color of the dropdown menu
    
        }),
        singleValue: (provided) => ({
          ...provided,
          position:"relative",
          color: '#ffffff', // Color of the selected value
          zIndex: 100, 
        }),
      };
    
    return (
        <Modal isOpen={isOpen} role="dialog" autoFocus={true} keyboard={false} centered backdrop="static" size="xl" data-toggle="modal">
            <div>
                <ModalHeader className="border-bottom-2">
                    <span className="modal-header-resource">Map Resources to Application Service</span>
                </ModalHeader>
            </div>
            <div className="modal-body">
                <Row className="full-width">
                    <Col lg="7" className="">
                        <h5 className="text-primary mb-3">Selected Resources</h5>
                        <Row>
                            {Object.keys(checkBox).map((key, index) => {
                                if (checkBox[key] === true) {
                                    return (
                                        <Col md="6" key={key}>
                                            <div className="border border-white bg-transparent text-white px-2 my-1">
                                                <CardBody className="p-0">
                                                    <div className="resource-logo-display mt-1">
                                                        {
                                                            <img src={type === "AWS" ? getAWSLogo(
                                                                filteredResources[key].resource_name, filteredResources[key].state) : type === "GCP" ? getGCPLogo(filteredResources[key].resource_name, filteredResources[key].state)
                                                                :type==='Azure' ? getAzureLogo(filteredResources[key].resource_name, filteredResources[key].state)
                                                                  : type === "Datadog" ? getStateSpecificDatadogLogo(filteredResources[key].resource_name, true)
                                                                    :type === "Splunk" ? getStateSpecificSplunkLogo(filteredResources[key].resource_name, true)
                                                                      :type === 'AppDynamics' ? getStateSpecificADLogo(filteredResources[key].resource_name, true)
                                                                        :type === 'Dynatrace' ? getDynatraceLogo(filteredResources[key].resource_name, true)
                                                                          :type === 'OCI' ? getOciLogo(filteredResources[key].resource_name)
                                                                            :type === 'Grafana' ? getGrafanaLogo(filteredResources[key].resource_name, true)
                                                                              :type === 'Signoz' ? getSignozLogo(filteredResources[key].resource_name, true)
                                                                                : getNRLogo(filteredResources[key].resource_name, filteredResources[key].is_application_active)} className="resource-logo" alt="Resource Logo" />
                                                      }
                                                        <h6 className="pt-2 resource-name-truncate">
                                                            {filteredResources[key].name}
                                                        </h6>
                                                    </div>
                                                </CardBody>
                                                <span className="close me-2" onClick={() => handleCheckBox(key)}></span>
                                            </div>
                                        </Col>
                                    );
                                }
                            })}
                        </Row>
                    </Col>
                    <Col lg="5" className="">
                        <h5 className="text-primary select-service mb-3">Select Application Service</h5>
                        <div className="text-center mb-4">
                            <div className="row justify-content-center">
                                <div className="col-xl-10">
                                    <div className="mb-2">
                                        <Select
                                            isClearable
                                            options={[
                                                ...serviceOptions, 
                                                { value: "/add-service", label: "Add new service" } 
                                              ]}
                                            placeholder="Select an Application Service"
                                            onChange={(selectedOption) => {
                                                if (selectedOption && selectedOption.value === "/add-service") {
                                                  window.location.href = "/add-service";
                                                } else {
                                                  handleServiceFormChange(selectedOption); 
                                                }
                                              }}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    neutral0: '#222736',
                                                    neutral5: '#485EC4',
                                                    neutral10: '#485EC4',
                                                    neutral60: '#ffffff',
                                                    neutral70: '#ffffff',
                                                    neutral80: '#ffffff',
                                                    neutral90: '#ffffff',
                                                    primary: '#485EC4',
                                                },
                                            })}
                                            styles={customStyles}
                                            getOptionLabel={(option) => customOptionRenderer(option)}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <Select
                                            isClearable
                                            options={environments}
                                            placeholder="Select an Environment"
                                            onChange={event => handleEnvironmentChange(event)}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    neutral0: '#222736',
                                                    neutral5: '#485EC4',
                                                    neutral10: '#485EC4',
                                                    neutral60: '#ffffff',
                                                    neutral70: '#ffffff',
                                                    neutral80: '#ffffff',
                                                    neutral90: '#ffffff',
                                                    primary: '#485EC4',
                                                },
                                            })}
                                            styles={customStyles}
                                        />
                                    </div>
                                    <Row className="full-width mt-4 pt-4">
                                        <Col lg="6" className="mt-4">
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                cancelMapServiceModal();
                                            }} className="btn btn-secondary w-md">Cancel</a>
                                        </Col>
                                        <Col lg="6" className="mt-4">
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                startLoading1();
                                                handleServiceMapping();
                                            }} className="btn btn-primary w-md">Map</a>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
}

export default MapResourceServiceModal;